import request from '@/utils/request';

/**
 * 获取SPUCode
 */
export function generateSPUCodeApi(data) {
  return request({
    url: "/admin/generator/generateSPUCode",
    method: 'POST',
    data: data
  });
}
/**
 * 获取SKUCode
 */
export function generateSKUCodeApi(data) {
  return request({
    url: "/admin/generator/generateSKUCode",
    method: 'POST',
    data: data
  });
}

/**
 * 获取SKUCode
 */
export function buchGenerateSKUCodeApi(data) {
  return request({
    url: "/admin/generator/batch/generateSKUCode",
    method: 'POST',
    data: data
  });
}

/**
 * 查询客户下拉列表
 */

export function getCustomersApi(params) {
  return request({
    url: "/admin/customers/options",
    method: 'GET',
    params: params
  });
}

/**
 * 获取分销商
 */
export function customersApi() {
  return request({
    url: "/admin/customers",
    method: 'GET',
    params: {
      page: 1,
      limit: 999,
      customerType: 3
    }
  });
}